import React from 'react';
const Tab = ({ title, onClick, active, ...rest }) => {
    return (React.createElement("div", { className: active ? 'tab active' : 'tab', onClick: onClick, ...rest }, title));
};
export default Tab;
